var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 18"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#logo_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2F54EB",
    d: "M10.886 4.518c-1.01.993-1.93 1.885-2.836 2.793-.371.372-.392.785-.003 1.167.376.368.776.39 1.17.019.123-.116.24-.238.358-.357 2.23-2.24 4.44-4.5 6.705-6.703.446-.434 1.073-.754 1.674-.938 1.186-.362 2.25.028 3.139.854a42 42 0 0 1 1.918 1.925c1.324 1.4 1.33 3.398-.034 4.775q-4.25 4.287-8.549 8.525c-1.436 1.416-3.433 1.41-4.86 0a1157 1157 0 0 1-8.55-8.525C-.335 6.689-.332 4.666.988 3.277a48 48 0 0 1 1.92-1.923C4.314.03 6.305.046 7.684 1.379c1.044 1.01 2.074 2.032 3.202 3.14z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "logo_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .363h24v17.273H0z"
  })))));
};
export default SvgLogo;